
<div
  class="chat-wrapper"
  [class.type-received]="type() === 'received'"
  [class.type-sent]="type() === 'sent'"
  [class.from-you]="sentFromYou() && type() === 'sent'"
  [class.show-received-metadata]="showReceivedMessageMetadata() === true"
  [class.centered]="messageAlignment() === 'center'"
  [class.hide-avatar]="hideAvatar()"
>
  @if (shouldShowProfilePic()) {
    <div class="avatar-wrapper">
      <div class="avatar">
        <glxy-avatar
          [src]="profilePicUrl()"
          [icon]="profileIcon()"
          [svgIcon]="profileSVGIcon()"
          [width]="36"
          [name]="messageFrom()"
          [backgroundColor]="profileBackgroundColor()"
        />
        @if (profileSourceIconName()) {
          <div [ngClass]="['profile-source-icon', 'source-' + profileSourceIconName()]"></div>
        }
      </div>
    </div>
  }

  <div class="chat-bubbles" [ngClass]="{ 'chat-bubbles-centered': messageAlignment() === 'center' }">
    <div class="chat-from-info">
      <strong>{{ sentFromYou() ? ('GALAXY.CHAT.YOU' | translate) : messageFrom() }}</strong>
      @if (messageFrom() && messageMetadata()) {
        <span>&nbsp;</span>
      }
      @if (messageMetadata()) {
        <span>{{ messageMetadata() }}</span>
      }
    </div>

    <ng-content />

    @if (isTyping()) {
      <glxy-chat-message [isTyping]="true" />
    }
  </div>
</div>
